export interface CategorySurveyMessage {
  ces: string;
  emo: string;
}

export interface SurveyMessage {
  FIRST_LOAN_FORM: CategorySurveyMessage;
  SECOND_LOAN_FORM: CategorySurveyMessage;
  LOGIN: CategorySurveyMessage;
  IN_PROCESS_LOAN: CategorySurveyMessage;
  REJECTED_LOAN: CategorySurveyMessage;
  LOAN_CONFIRMATION: CategorySurveyMessage;
  OFFLINE_CONTRACT: CategorySurveyMessage;
  DISBURSEMENT: CategorySurveyMessage;
  ACTIVE_NORMAL: CategorySurveyMessage;
  IN_DEBT: CategorySurveyMessage;
  PAIDBACK_PENDING: CategorySurveyMessage;
  DIGITAL_CONTRACT: CategorySurveyMessage;
  PAIDBACK: CategorySurveyMessage;
  FAQ: CategorySurveyMessage;
  OTHER: CategorySurveyMessage;
}

export const /** @type {?} */ surveyMessage: SurveyMessage = {
  FIRST_LOAN_FORM: {
    ces: 'pengisian formulir di Tunaiku?',
    emo: 'saat mengisi formulir pinjaman di Tunaiku?',
  },
  SECOND_LOAN_FORM: {
    ces: 'pengisian formulir di Tunaiku?',
    emo: 'saat mengisi formulir pinjaman di Tunaiku?',
  },
  LOGIN: {
    ces: 'proses masuk akun di Tunaiku?',
    emo: 'saat proses masuk akun di Tunaiku?',
  },
  IN_PROCESS_LOAN: {
    ces: 'pengajuan pinjaman di Tunaiku?',
    emo: 'saat mengajukan pinjaman di Tunaiku?',
  },
  REJECTED_LOAN: {
    ces: 'pengajuan pinjaman di Tunaiku?',
    emo: 'saat mengajukan pinjaman di Tunaiku?',
  },
  LOAN_CONFIRMATION: {
    ces: 'pengajuan pinjaman di Tunaiku?',
    emo: 'saat mengajukan pinjaman di Tunaiku?',
  },
  OFFLINE_CONTRACT: {
    ces: 'proses tanda tangan kontrak di Tunaiku?',
    emo: 'saat proses tanda tangan kontrak di Tunaiku?',
  },
  DISBURSEMENT: {
    ces: 'proses pencairan dana di Tunaiku?',
    emo: 'saat pencairan dana di Tunaiku?',
  },
  ACTIVE_NORMAL: {
    ces: 'Anda memahami informasi di menu Pinjamanku?',
    emo: 'saat mendapatkan informasi di menu Pinjamanku?',
  },
  IN_DEBT: {
    ces: 'Anda memahami informasi di menu Pinjamanku?',
    emo: 'saat mendapatkan informasi di menu Pinjamanku?',
  },
  PAIDBACK_PENDING: {
    ces: 'pengalaman meminjam di Tunaiku?',
    emo: 'setelah meminjam di Tunaiku?',
  },
  DIGITAL_CONTRACT: {
    ces: 'proses kontrak online di Tunaiku?',
    emo: 'saat proses kontrak online di Tunaiku?',
  },
  PAIDBACK: {
    ces: 'pengalaman meminjam di Tunaiku?',
    emo: 'setelah meminjam di Tunaiku?',
  },
  FAQ: {
    ces: 'proses pencarian informasi di Tunaiku?',
    emo: 'saat mencari informasi di Tunaiku?',
  },
  OTHER: {
    ces: 'proses pencarian informasi di Tunaiku?',
    emo: 'saat mencari informasi di Tunaiku?',
  },
};
